import {Component} from '@angular/core';

@Component({
  selector: 'app-privacy',
  template: `
    <div style="text-align: center; margin: 10px">
      IKEA internal use only GDPR data regulations apply
    </div>
  `,
})
export class AppPrivacyComponent {
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/app.privacy.component.ts